<ng-template #popTemplate>
    <div [innerHtml]="message"></div>
</ng-template>
<i class='{{classIcon}} {{colorIcon}}' [popover]="popTemplate" triggers="mouseenter:mouseleave"
    [adaptivePosition]="true" container="body" boundariesElement="viewport" placement="top"></i>